import React from 'react'
import botFlowSchema from '@feedyou/schema/schema/botFlow.json'

import { WithModelSpecificPropertyWarning } from '../../design-system/RjsfDescriptionLinks/variants'

const knowledgeBaseSchema = botFlowSchema.properties.knowledgeBases.items.properties

export function useKnowledgeBaseUiSchema() {
  return {
    'ui:order': ['id', 'name', 'retrieval', 'reasoningEffort', 'defaultDocumentSettings'],
    reasoningEffort: {
      'ui:description': (
        <WithModelSpecificPropertyWarning>
          {knowledgeBaseSchema.reasoningEffort.description}
        </WithModelSpecificPropertyWarning>
      )
    },
    retrieval: {
      type: { 'ui:widget': 'hidden' },
      queryLlmChatService: {
        'ui:widget': 'BotCloudServiceSelectWidget',
        kind: 'llm-chat',
        action: 'KB search query'
      }
    }
  }
}
